<template>
    <div class="page-height">
        <div class="card">
            <div class="card-header">
                <h4 class="card-title mb-0">Create Order</h4>
            </div>

            <div class="card-body form-steps">
                <div class="select-step">
                    <!-- progressbar -->
                    <ul id="progressbar" class="mb-4">
                        <!--<li class="active"><span>Select Customer</span></li>
                        <li class="active"><span>Select Quotes</span></li>
                        <li class="active"><span>Select Products</span></li>
                        <li class="active"><span>Provide Other Info</span></li>-->
                        <li><span>Select Customer</span></li>
                        <li><span>Select Quotes</span></li>
                        <li><span>Select Products</span></li>
                        <li class="active"><span>Provide Other Info</span></li>
                    </ul>

                    <div class="setp4col">
                        <div class="rowcol1">
                            <div class="">
                                <div class="step4row-height">
                                    <div
                                        class="table-responsive product-status"
                                        v-if="
                                            newOrder.products.filter(
                                                (x) => x.quote_product_id
                                            ).length
                                        "
                                    >
                                        <h4>Quotation Products</h4>
                                        <table
                                            class="table table-striped table-bordered mb-2"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Quote #</th>
                                                    <th>Item #</th>
                                                    <th>
                                                        Product Name and
                                                        Description
                                                    </th>
                                                    <th>Qty Tier</th>
                                                    <th>UOM</th>
                                                    <th>Retail price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(
                                                        product, index
                                                    ) in newOrder.products.filter(
                                                        (x) =>
                                                            x.quote_product_id
                                                    )"
                                                    class="product-table-item"
                                                >
                                                    <td>
                                                        <template
                                                            v-if="
                                                                product.quotation
                                                            "
                                                            >#{{
                                                                product
                                                                    .quotation
                                                                    .quotation_number
                                                            }}</template
                                                        >
                                                    </td>
                                                    <td>
                                                        <template
                                                            v-if="
                                                                product.product_id
                                                            "
                                                            >#{{
                                                                product.product_num
                                                            }}</template
                                                        >
                                                    </td>
                                                    <td>
                                                        {{
                                                            product.product_name
                                                        }}
                                                        <div
                                                            v-html="
                                                                product.product_desc
                                                            "
                                                        ></div>
                                                    </td>
                                                    <td>{{ product.qty }}</td>
                                                    <td>
                                                        {{
                                                            getSelectedQuantityUnit(
                                                                product.qty_unit_id
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        ${{ product.price }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div
                                        class="table-responsive product-status"
                                        v-if="
                                            newOrder.products.filter(
                                                (x) => !x.quote_product_id
                                            ).length
                                        "
                                    >
                                        <h4>All Products</h4>
                                        <table
                                            class="table table-striped table-bordered mb-2"
                                        >
                                            <thead>
                                                <tr>
                                                    <th style="width: 160px">
                                                        Item #
                                                    </th>
                                                    <!-- <th style="width: 160px">
                                                        SO
                                                    </th> -->
                                                    <th style="width: 450px">
                                                        Product Name and
                                                        Description
                                                    </th>
                                                    <th style="width: 150px">
                                                        Quantity
                                                        <!-- <template v-for="(
                                                        product, index
                                                    ) in newOrder.products.filter(
                                                        (x) =>
                                                            !x.quote_product_id
                                                    )">
                                                    /{{
                                                            getSelectedQuantityUnit(
                                                                product.qty_unit_id
                                                            )
                                                        }}
                                                    </template> -->
                                                    </th>
                                                    <!-- <th>UOM</th> -->
                                                    <th style="width: 150px">
                                                        Selling price
                                                    </th>
                                                    <th style="width: 150px">
                                                        Purchase price
                                                    </th>
                                                    <!-- <th>Vendor</th> -->
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(
                                                        product, index
                                                    ) in newOrder.products.filter(
                                                        (x) =>
                                                            !x.quote_product_id
                                                    )"
                                                    class="product-table-item"
                                                >
                                                    <td>
                                                        #{{
                                                            product.product_num
                                                        }}
                                                    </td>
                                                    <!-- <td>
                                                        <template
                                                            v-if="
                                                                product.latest_order
                                                            "
                                                        >
                                                            <router-link
                                                                :to="{
                                                                    name: 'orderShow',
                                                                    params: {
                                                                        id: product
                                                                            .latest_order
                                                                            .id,
                                                                    },
                                                                }"
                                                                target="_blank"
                                                                >#{{
                                                                    product
                                                                        .latest_order
                                                                        .order_number
                                                                }}</router-link
                                                            >
                                                        </template>
                                                    </td> -->
                                                    <td>
                                                        {{
                                                            product.product_name
                                                        }}
                                                        <div
                                                            v-html="
                                                                product.product_desc
                                                            "
                                                        ></div>
                                                    </td>
                                                    <td>{{ product.qty }}</td>
                                                    <!-- <td>
                                                        {{
                                                            getSelectedQuantityUnit(
                                                                product.qty_unit_id
                                                            )
                                                        }}
                                                    </td> -->
                                                    <td>
                                                        ${{ product.price }}
                                                    </td>
                                                    <td>
                                                        ${{
                                                            product.vendor_cost
                                                        }}
                                                    </td>
                                                    <!-- <td>
                                                        {{
                                                            getVendorName(
                                                                product
                                                            )
                                                        }}
                                                    </td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <ValidationObserver v-slot="{ handleSubmit }">
                                <div class="otherinfoBelow">
                                    <form
                                        @submit.prevent="
                                            handleSubmit(saveOrder)
                                        "
                                        ref="orderForm"
                                        method="post"
                                    >
                                        <div class="row justify-content-center">
                                            <div class="col-sm-12 col-md-12">
                                                <div class="row">
                                                    <div
                                                        class="col-sm-3 col-md-3"
                                                    >
                                                        <div class="form-group">
                                                            <label
                                                                >Order
                                                                Number</label
                                                            >
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder=""
                                                                name="order_number"
                                                                v-model="
                                                                    newOrder.order_number
                                                                "
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-sm-3 col-md-3"
                                                    >
                                                        <ValidationProvider
                                                            name="Creation date"
                                                            rules="required"
                                                            v-slot="{ errors }"
                                                        >
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    >Order
                                                                    date</label
                                                                >
                                                                <date-picker
                                                                    v-model="
                                                                        newOrder.order_date
                                                                    "
                                                                    format="MM/DD/YYYY"
                                                                    :input-class="{
                                                                        error: errors.length,
                                                                        'mx-input': true,
                                                                    }"
                                                                    valueType="format"
                                                                ></date-picker>
                                                                <div
                                                                    class="error"
                                                                    v-if="
                                                                        errors.length
                                                                    "
                                                                >
                                                                    {{
                                                                        errors[0]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </ValidationProvider>
                                                    </div>
                                                    <!--<div class="col-sm-3 col-md-3">
                                                        <div class="form-group">
                                                            <label>Estimated Delivery Time</label>
                                                            <select class="form-control" v-model="eta_time">
                                                                <option :value="null">Select Time</option>
                                                                <option value="16_W">16 Weeks</option>
                                                                <option value="14_W">14 Weeks</option>
                                                                <option value="10_W">10 Weeks</option>
                                                                <option value="30_D">30 Days</option>
                                                            </select>
                                                        </div>
                                                    </div>-->
                                                    <div
                                                        class="col-sm-3 col-md-3"
                                                    >
                                                        <ValidationProvider
                                                            name="ETA"
                                                            rules="required"
                                                            v-slot="{ errors }"
                                                        >
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    >Estimated
                                                                    Delivery
                                                                    Date</label
                                                                >
                                                                <!--
                                                                <date-picker v-model="newOrder.eta" valueType="format" format="MM/DD/YYYY"
                                                                             :input-class="{error: errors.length, 'mx-input': true}"></date-picker>
                                                                             -->
                                                                <date-range-picker
                                                                    ref="picker"
                                                                    :singleDatePicker="
                                                                        true
                                                                    "
                                                                    :autoApply="
                                                                        true
                                                                    "
                                                                    :locale-data="{
                                                                        firstDay: 1,
                                                                        format: 'mm/dd/yyyy',
                                                                    }"
                                                                    :ranges="
                                                                        ranges
                                                                    "
                                                                    v-model="
                                                                        etaRange
                                                                    "
                                                                >
                                                                </date-range-picker>
                                                                <div
                                                                    class="error"
                                                                    v-if="
                                                                        errors.length
                                                                    "
                                                                >
                                                                    {{
                                                                        errors[0]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </ValidationProvider>
                                                    </div>
                                                    <div
                                                        class="col-sm-3 col-md-3"
                                                    >
                                                        <ValidationProvider
                                                            name="Sales Rep"
                                                            rules="required"
                                                            v-slot="{ errors }"
                                                        >
                                                            <div
                                                                class="form-group"
                                                            >
                                                                <label
                                                                    >Sales
                                                                    Rep</label
                                                                >
                                                                <b-form-select
                                                                    v-model="
                                                                        newOrder.sales_rep_id
                                                                    "
                                                                    :class="{
                                                                        error: errors.length,
                                                                    }"
                                                                    :options="
                                                                        salesReps
                                                                    "
                                                                ></b-form-select>
                                                                <div
                                                                    class="error"
                                                                    v-if="
                                                                        errors.length
                                                                    "
                                                                >
                                                                    {{
                                                                        errors[0]
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </ValidationProvider>
                                                    </div>

                                                    <!-- <div class="col-sm-3 col-md-3">
                                                        <div class="form-group">
                                                            <label>Payment Terms</label>

                                                            <vue-editor v-model="newOrder.purchase_terms" :editorToolbar="getQuillToolbar()"></vue-editor>

                                                        </div>
                                                    </div> -->
                                                    <div
                                                        class="col-sm-3 col-md-3"
                                                    >
                                                        <div class="form-group">
                                                            <label
                                                                >Customer
                                                                PO</label
                                                            >
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder=""
                                                                name="customer_po"
                                                                v-model="
                                                                    newOrder.customer_po
                                                                "
                                                            />
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="col-sm-3 col-md-3"
                                                    >
                                                        <div class="form-group">
                                                            <label>FOB</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder=""
                                                                name="fob"
                                                                v-model="
                                                                    newOrder.fob
                                                                "
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-sm-3 col-md-3"
                                                    >
                                                        <div class="form-group">
                                                            <label
                                                                >Payment
                                                                Terms</label
                                                            >
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder=""
                                                                name="customer_terms"
                                                                v-model="
                                                                    newOrder.customer_terms
                                                                "
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-sm-3 col-md-3"
                                                    >
                                                        <div class="form-group">
                                                            <label
                                                                >Quote
                                                                Number</label
                                                            >
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder=""
                                                                name="customer_terms"
                                                                v-model="
                                                                    newOrder
                                                                        .quotations[0]
                                                                "
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-sm-6 col-md-6"
                                                    >
                                                        <div class="form-group">
                                                            <label
                                                                >Customer
                                                                Notes</label
                                                            >
                                                            <!--<textarea rows="2" cols="75" class="form-control"
                                                                   v-model="newOrder.customer_notes"></textarea>-->
                                                            <vue-editor
                                                                v-model="
                                                                    newOrder.customer_notes
                                                                "
                                                                :editorToolbar="
                                                                    getQuillToolbar()
                                                                "
                                                            ></vue-editor>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="col-sm-6 col-md-6"
                                                    >
                                                        <div class="form-group">
                                                            <label
                                                                >Internal
                                                                Notes</label
                                                            >
                                                            <!--<textarea rows="2" cols="75" class="form-control"
                                                                    v-model="newOrder.notes"></textarea>-->
                                                            <vue-editor
                                                                v-model="
                                                                    newOrder.notes
                                                                "
                                                                :editorToolbar="
                                                                    getQuillToolbar()
                                                                "
                                                            ></vue-editor>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-sm-12 col-md-12 mb-2"
                                                    >
                                                        <div
                                                            class="radiogroups"
                                                        >
                                                            <div
                                                                class="form-check-inline"
                                                            >
                                                                Stocking?
                                                            </div>
                                                            <div
                                                                class="form-check-inline"
                                                            >
                                                                <label
                                                                    class="form-check-label"
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        class="form-check-input"
                                                                        name="is_stocking"
                                                                        value="1"
                                                                        v-model="
                                                                            newOrder.is_stocking
                                                                        "
                                                                    />
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div
                                                                class="form-check-inline"
                                                            >
                                                                <label
                                                                    class="form-check-label"
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        class="form-check-input"
                                                                        name="is_stocking"
                                                                        value="0"
                                                                        v-model="
                                                                            newOrder.is_stocking
                                                                        "
                                                                    />
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-sm-12 col-md-12"
                                                        v-if="
                                                            newOrder.is_stocking ==
                                                            1
                                                        "
                                                    >
                                                        <div class="form-group">
                                                            <label
                                                                >Stocking
                                                                Terms</label
                                                            >
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder=""
                                                                v-model="
                                                                    newOrder.stocking_terms
                                                                "
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-sm-6 col-md-6"
                                                        v-if="
                                                            newOrder.is_stocking ==
                                                            1
                                                        "
                                                    >
                                                        <div
                                                            class="form-group"
                                                            v-for="(
                                                                warehouse, index
                                                            ) in newOrder.warehouses"
                                                        >
                                                            <div
                                                                class="selectship"
                                                            >
                                                                <label
                                                                    >Superb
                                                                    Warehouse</label
                                                                >
                                                                <select
                                                                    name="cars"
                                                                    class="custom-select"
                                                                    @change.prevent="
                                                                        warehouseChange(
                                                                            $event,
                                                                            'warehouses',
                                                                            index
                                                                        )
                                                                    "
                                                                >
                                                                    <option
                                                                        :value="
                                                                            null
                                                                        "
                                                                        :selected="
                                                                            !warehouse.warehouse_id
                                                                        "
                                                                    >
                                                                        Select
                                                                        Warehouse
                                                                    </option>
                                                                    <option
                                                                        v-for="item in warehouses"
                                                                        :value="
                                                                            item.id
                                                                        "
                                                                    >
                                                                        {{
                                                                            item.name
                                                                        }}
                                                                    </option>
                                                                    <option
                                                                        value="add_new"
                                                                    >
                                                                        Add New
                                                                    </option>
                                                                </select>
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    @click="
                                                                        removeWarehouse(
                                                                            index
                                                                        )
                                                                    "
                                                                    v-if="
                                                                        newOrder
                                                                            .warehouses
                                                                            .length >
                                                                        1
                                                                    "
                                                                    class="btn btn-danger px-3 py-2"
                                                                    ><i
                                                                        class="ri-delete-bin-6-line"
                                                                    ></i
                                                                ></a>
                                                            </div>
                                                            <textarea
                                                                class="form-control"
                                                                placeholder=""
                                                                v-model="
                                                                    newOrder
                                                                        .warehouses[
                                                                        index
                                                                    ].address
                                                                "
                                                            ></textarea>
                                                        </div>
                                                        <div
                                                            class="addshipbtn"
                                                            v-if="
                                                                newOrder
                                                                    .warehouses
                                                                    .length <
                                                                maxNumOfShipToAddress
                                                            "
                                                        >
                                                            <a
                                                                @click="
                                                                    addWarehouse()
                                                                "
                                                                href="javascript:void(0);"
                                                                class="btn btn-primary addbtn1"
                                                                ><i
                                                                    class="fa fa-plus-circle"
                                                                    aria-hidden="true"
                                                                ></i
                                                            ></a>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-sm-6 col-md-6"
                                                    >
                                                        <div
                                                            class="form-group"
                                                            v-for="(
                                                                warehouse, index
                                                            ) in newOrder.customerWarehouses"
                                                        >
                                                            <div
                                                                class="selectship"
                                                            >
                                                                <label
                                                                    >Ship
                                                                    To</label
                                                                >
                                                                <select
                                                                    name="cars"
                                                                    class="custom-select"
                                                                    v-model="
                                                                        newOrder
                                                                            .customerWarehouses[
                                                                            index
                                                                        ]
                                                                            .warehouse_id
                                                                    "
                                                                    @change.prevent="
                                                                        warehouseChange(
                                                                            $event,
                                                                            'customerWarehouses',
                                                                            index
                                                                        )
                                                                    "
                                                                >
                                                                    <option
                                                                        :value="
                                                                            null
                                                                        "
                                                                    >
                                                                        Select
                                                                        Warehouse
                                                                    </option>
                                                                    <option
                                                                        v-for="item in customerWarehouses"
                                                                        :value="
                                                                            item.id
                                                                        "
                                                                    >
                                                                        {{
                                                                            item.name
                                                                        }}
                                                                    </option>
                                                                    <option
                                                                        value="add_new"
                                                                    >
                                                                        Add New
                                                                    </option>
                                                                </select>

                                                                <!--
                                                                <select name="cars" class="custom-select" @change.prevent="warehouseChange($event, 'customerWarehouses', index)">
                                                                    <option :value="null" :selected="!warehouse.warehouse_id">Select Warehouse</option>
                                                                    <option v-for="(item) in customerWarehouses" :value="item.id">{{item.address}}</option>
                                                                    <option value="add_new">Add New</option>
                                                                </select>
                                                                -->

                                                                <a
                                                                    href="javascript:void(0);"
                                                                    @click="
                                                                        removeCustomerWarehouse(
                                                                            index
                                                                        )
                                                                    "
                                                                    v-if="
                                                                        newOrder
                                                                            .customerWarehouses
                                                                            .length >
                                                                        1
                                                                    "
                                                                    class="btn btn-danger px-3 py-2"
                                                                    ><i
                                                                        class="ri-delete-bin-6-line"
                                                                    ></i
                                                                ></a>
                                                            </div>
                                                            <textarea
                                                                class="form-control"
                                                                placeholder=""
                                                                v-model="
                                                                    newOrder
                                                                        .customerWarehouses[
                                                                        index
                                                                    ].address
                                                                "
                                                            ></textarea>
                                                        </div>
                                                        <div
                                                            class="addshipbtn"
                                                            v-if="
                                                                newOrder
                                                                    .customerWarehouses
                                                                    .length <
                                                                maxNumOfShipToAddress
                                                            "
                                                        >
                                                            <a
                                                                @click="
                                                                    addCustomerWarehouse()
                                                                "
                                                                href="javascript:void(0);"
                                                                class="btn btn-primary addbtn1"
                                                                ><i
                                                                    class="fa fa-plus-circle"
                                                                    aria-hidden="true"
                                                                ></i
                                                            ></a>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="col-sm-6 col-md-6"
                                                    >
                                                        <div
                                                            class="form-group"
                                                             v-for="(
                                                                warehouse, index
                                                            ) in newOrder.billTo"
                                                        >
                                                            <div
                                                                class="selectship"
                                                            >
                                                                <label
                                                                    >Bill To 
                                                                </label>
                                                                <select
                                                                    name="cars"
                                                                    class="custom-select"
                                                                    @change.prevent="
                                                                        warehouseChange(
                                                                            $event,
                                                                            'billTo',
                                                                            index
                                                                        )
                                                                    "
                                                                >
                                                                    <option
                                                                        :value="
                                                                            null
                                                                        "
                                                                        :selected="
                                                                            !warehouse.warehouse_id
                                                                        "
                                                                    >
                                                                        Select
                                                                        Address
                                                                    </option>
                                                                    <!-- <option
                                                                        v-for="item in newOrder
                                                                            .customer
                                                                            .customer_contacts"
                                                                        :value="
                                                                            item.contact_id
                                                                        "
                                                                    >
                                                                        {{
                                                                            item.contact_name
                                                                        }}
                                                                        
                                                                    </option> -->

                                                                    <!-- <option
                                                                        v-for="item in customerWarehouses"
                                                                        :value="
                                                                            item.id
                                                                        "
                                                                    >
                                                                        {{
                                                                            item.name
                                                                        }} 
                                                                    </option> -->

                                                                    <option v-if="newOrder.customer"
                                                                        selected
                                                                        :value="
                                                                            newOrder.customer.id
                                                                        "
                                                                    >
                                                                        {{
                                                                            newOrder.customer.company_name
                                                                        }} 
                                                                    </option> 

                                                                    <!-- <option
                                                                        value="add_new"
                                                                    >
                                                                        Add New
                                                                    </option> -->
                                                                </select>

                                                                <a
                                                                    href="javascript:void(0);"
                                                                    @click="
                                                                        removeBillTo(
                                                                            index
                                                                        )
                                                                    "
                                                                    v-if="
                                                                        newOrder
                                                                            .billTo
                                                                            .length >
                                                                        1
                                                                    "
                                                                    class="btn btn-danger px-3 py-2"
                                                                    ><i
                                                                        class="ri-delete-bin-6-line"
                                                                    ></i
                                                                ></a>
                                                            </div>
                                                            <textarea
                                                                class="form-control"
                                                                placeholder=""
                                                                v-model="
                                                                    newOrder
                                                                        .billTo[
                                                                        index
                                                                    ].address
                                                                "
                                                            ></textarea>
                                                        </div>
                                                        <div
                                                            class="addshipbtn"
                                                            v-if="
                                                                newOrder.billTo
                                                                    .length <
                                                                maxNumOfShipToAddress
                                                            "
                                                        >
                                                            <a
                                                                @click="
                                                                    addBillTo()
                                                                "
                                                                href="javascript:void(0);"
                                                                class="btn btn-primary addbtn1"
                                                                ><i
                                                                    class="fa fa-plus-circle"
                                                                    aria-hidden="true"
                                                                ></i
                                                            ></a>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="col-sm-12 col-md-12"
                                                    >
                                                        <template
                                                            v-if="
                                                                charges.length >
                                                                0
                                                            "
                                                        >
                                                            <div
                                                                v-for="(
                                                                    charge,
                                                                    index
                                                                ) in charges"
                                                                :key="
                                                                    'type_' +
                                                                    charge.id +
                                                                    '_' +
                                                                    charge.cost_type +
                                                                    '_' +
                                                                    index
                                                                "
                                                            >
                                                                <div
                                                                    class="quantity-row"
                                                                >
                                                                    <div
                                                                        class="quantity-col1"
                                                                    >
                                                                        <a
                                                                            href="javascript:void(0);"
                                                                            v-on:click="
                                                                                editCharge(
                                                                                    index,
                                                                                    charge
                                                                                )
                                                                            "
                                                                            >{{
                                                                                charge.cost_type
                                                                            }}:</a
                                                                        >
                                                                        <template
                                                                            v-if="
                                                                                charge.quantity !=
                                                                                    null &&
                                                                                charge.quantity >
                                                                                    0
                                                                            "
                                                                        >
                                                                            ${{
                                                                                charge.amount
                                                                            }}
                                                                            x{{
                                                                                charge.quantity
                                                                            }}
                                                                        </template>
                                                                    </div>
                                                                    <span
                                                                        class="cdl"
                                                                        >:</span
                                                                    >
                                                                    <div
                                                                        class="quantity-col2"
                                                                    >
                                                                        ${{
                                                                            charge.quantity !=
                                                                                null &&
                                                                            charge.quantity >
                                                                                0
                                                                                ? charge.amount *
                                                                                  charge.quantity
                                                                                : charge.amount
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <a
                                                            href="javascript:void(0);"
                                                            data-toggle="modal"
                                                            data-target="#extraChargeModal"
                                                            class="btn btn-primary px-3 py-2"
                                                            >Add charge</a
                                                        >

                                                        <!--<template v-else> _</template>-->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="btnrow text-right">
                                            <button
                                                type="button"
                                                @click="goBack"
                                                class="btn btn-light btn-label left-btn previestab w-lg"
                                                data-previous="steparrow-gen-info-tab"
                                            >
                                                <i
                                                    class="ri-arrow-left-line label-icon align-middle fs-16 me-2"
                                                ></i>
                                                Back
                                            </button>
                                            <button
                                                type="button"
                                                @click="saveAsDraft"
                                                :disabled="
                                                    ordersLoading ||
                                                    loading ||
                                                    saveDone == true
                                                "
                                                class="btn custom-btn ml-3"
                                            >
                                                Save As Draft
                                            </button>
                                            <button
                                                type="submit"
                                                ref="submitButton"
                                                :disabled="
                                                    ordersLoading ||
                                                    loading ||
                                                    saveDone == true
                                                "
                                                class="btn btn-success right btn-label ml-3"
                                            >
                                                <i
                                                    class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"
                                                ></i>
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                    </div>
                                </ValidationObserver>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <OrderExtraChargeModal
            :order="null"
            :sub_total_cost="null"
            :charge="charge"
            :bus="bus"
            ref="orderExtraCharge"
            @extraChargeAdded="extraChargeAdded"
        ></OrderExtraChargeModal>
        <AddWarehouse
            :loading="loading"
            :customerId="newOrder.customer_id"
            :warehouseAddType="warehouseAddType"
            @addedEvent="warehouseAddedEvent"
        ></AddWarehouse>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import * as moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import OrderExtraChargeModal from "../../components/OrderExtraChargeModal";
import Vue from "vue";
import { VueEditor } from "vue2-editor";
import AddWarehouse from "../../components/AddWarehouse";

export default {
    name: "ProvideOtherInfo",
    components: {
        DatePicker,
        ValidationProvider,
        ValidationObserver,
        OrderExtraChargeModal,
        VueEditor,
        AddWarehouse,
    },
    created() {
        if (localStorage.getItem("token")) {
            axios.defaults.headers.common["Authorization"] =
                "Bearer " + localStorage.getItem("token");
        }
        if (this.salesOrderState) {
            this.newOrder = this.salesOrderState.newOrder;
            // console.log(" newOrder ",this.newOrder)
            if (this.newOrder.order_date == null) {
                this.newOrder.order_date = moment().format("MM/DD/YYYY");
            }
        }
        this.getSalesRep();
    },
    data() {
        return {
            bus: new Vue(),
            newOrder: {
                id: null,
                is_draft: 0,
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [],
                customerWarehouses: [],
                billTo: [],
                customer_id: null,
                sales_rep_id: null,
                order_number: null,
                order_date: null,
                customer_terms: null,
                customer_po: null,
                eta: null,
                fob: null,
                notes: null,
                customer_notes: null,
                quotations: [],
                customer: {
                    quotations_after_sent_to_customer: [],
                },
                products: [],
                selectedProducts: [],
            },
            salesReps: [],
            submitted: false,
            saveDone: false,
            discounts: [],
            charges: [],
            chargeIndex: null,
            charge: null,
            warehouses: [],
            customerWarehouses: [],
            quantityUnits: [],
            eta_time: null,
            etaRange: {
                startDate: null,
                endDate: null,
            },
            ranges: {
                "16 weeks": [
                    moment().add(16, "weeks").toDate(),
                    moment().add(16, "weeks").toDate(),
                ],
                "14 weeks": [
                    moment().add(14, "weeks").toDate(),
                    moment().add(14, "weeks").toDate(),
                ],
                "10 weeks": [
                    moment().add(10, "weeks").toDate(),
                    moment().add(10, "weeks").toDate(),
                ],
                "30 Days": [
                    moment().add(30, "days").toDate(),
                    moment().add(30, "days").toDate(),
                ],
            },
            warehouseAddType: null,
            warehouseAddIndex: null,
        };
    },
    mounted() {
        console.log("new order data : ", this.newOrder);
        this.getOrderNum();
        this.getQuantityUnits();
        if (
            this.newOrder.customer &&
            (this.newOrder.customer_notes == null ||
                this.newOrder.customer_notes == "")
        ) {
            this.newOrder.customer_notes =
                this.newOrder.customer.customer_so_note;
        }
        if (
            this.newOrder.customer &&
            (this.newOrder.customer_terms == null ||
                this.newOrder.customer_terms == "")
        ) {
            // this.newOrder.customer_terms = this.newOrder.customer.purchase_terms;
            this.newOrder.customer_terms =
                this.newOrder.customer.customer_payment_terms;
        }
        if (
            this.newOrder.customer &&
            (this.newOrder.stocking_terms == null ||
                this.newOrder.stocking_terms == "")
        ) {
            // this.newOrder.customer_terms = this.newOrder.customer.purchase_terms;
            this.newOrder.stocking_terms =
                this.newOrder.customer.stocking_terms;
        }
        this.getWarehouses(0);
        this.getWarehouses(1);
        this.newOrder.products = this.newOrder.products.filter((x) => {
            if (x.quote_product_id) {
                return this.newOrder.selectedProducts.includes(
                    x.quote_product_id
                );
            } else {
                return this.newOrder.selectedProducts.includes(x.product_id);
            }
        });

        if (
            this.newOrder.customerWarehouses &&
            this.newOrder.customerWarehouses.length == 0
        ) {
            this.newOrder.customerWarehouses = [
                {
                    id: null,
                    warehouse_id: null,
                    address: null,
                },
            ];
        }
        if (this.newOrder.billTo && this.newOrder.billTo.length == 0) {
            this.newOrder.billTo = [
                {
                    id: null,
                    warehouse_id: null,
                    address: null,
                },
            ];
        }
        if (
            this.settings &&
            this.settings.so_setting &&
            this.settings.so_setting.default_so_note
        ) {
            if (this.newOrder.notes == null || this.newOrder.notes == "") {
                this.newOrder.notes = this.settings.so_setting.default_so_note;
            }
        }

        if (!this.newOrder.quotations || this.newOrder.quotations.length == 0) {
            this.newOrder.quotations = [null];
        }

        console.log("this.newOrder",this.newOrder);
        this.newOrder.billTo.forEach((b, i) => {

            console.log("billTo ",b);
           // if (b.warehouse_id) {
            this.warehouseChange({ target: { value: '' } }, 'billTo', i);
            //}
        });



        //this.newOrder.products = this.newOrder.products.filter((x) => this.newOrder.selectedProducts.includes(x.product_id));
    },
    beforeRouteLeave(to, from, next) {
        if (this.saveDone || to.name == "selectProducts") {
            next();
        } else {
            const answer = window.confirm(
                "Do you really want to leave? you have unsaved changes!"
            );
            if (answer) {
                next();
            } else {
                next(false);
            }
        }
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setNewOrder",
            "setOrdersLoading",
            "setLoading",
        ]),
        getOrderNum() {
            let self = this;
            this.setOrdersLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("so.initOrderNumber"), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        if (data.data) {
                            this.newOrder.order_number = data.data;
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setOrdersLoading(false);
                });
        },
        getVendorName(product) {
            let vendor = this.getVendorFromProduct(product);
            if (vendor) {
                return vendor.company_name;
            }
            return null;
        },
        getVendorFromProduct(product) {
            if (product.vendor) {
                return product.vendor;
            } else if (product.quotation_products) {
                let vendor = null;
                product.quotation_products.forEach((qp) => {
                    if (qp.quotation_prices && vendor == null) {
                        qp.quotation_prices.forEach((qpp) => {
                            if (qpp.vendor && vendor == null) {
                                vendor = _.cloneDeep(qpp.vendor);
                            }
                        });
                    }
                });
                return vendor;
            }
            return null;
        },
        getSelectedQuantityUnit(qty_unit_id) {
            if (qty_unit_id && this.quantityUnits.length) {
                let qty_unit = this.quantityUnits.find(
                    (x) => x.id == qty_unit_id
                );
                if (qty_unit) {
                    return qty_unit.name;
                }
            }
            return null;
        },
        getQuantityUnits() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("so-quantity-units.index"), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.quantityUnits = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setLoading(false);
                });
        },
        addWarehouse() {
            this.newOrder.warehouses.push({
                id: null,
                warehouse_id: null,
                address: null,
            });
        },
        removeWarehouse(index) {
            this.newOrder.warehouses.splice(index, 1);
        },
        addCustomerWarehouse() {
            this.newOrder.customerWarehouses.push({
                id: null,
                warehouse_id: null,
                address: null,
            });
        },
        removeCustomerWarehouse(index) {
            this.newOrder.customerWarehouses.splice(index, 1);
        },
        warehouseAddedEvent(warehouse) {
            if (
                this.warehouseAddType == "billTo" ||
                this.warehouseAddType == "customerWarehouses"
            ) {
                this.customerWarehouses.push(warehouse);
            } else {
                this.customerWarehouses.push(warehouse);
            }

            let address = warehouse.name;
                address += '\n'+warehouse.address;
            if (warehouse.city) {
                address += `\n ${warehouse.city}`;
            }
            if (warehouse.state) {
                address += ` ${warehouse.state}`;
            }
            if (warehouse.post_code) {
                address += ` ${warehouse.post_code}`;
            }

            this.newOrder[this.warehouseAddType][
                this.warehouseAddIndex
            ].warehouse_id = warehouse.id;

            this.newOrder[this.warehouseAddType][
                this.warehouseAddIndex
            ].address = address;

            setTimeout(() => {
                this.warehouseAddIndex = null;
                this.warehouseAddType = null;
                $("#addWarehouseModal").modal("hide");
            }, 5000);
        },
        warehouseChange(event, type, index) {
            console.log("dddddddddddd", event.target.value);
            console.log("type", type);
            //console.log("warehouses", this.warehouses);
            if (event.target.value == "add_new") {
                this.warehouseAddType = type;
                this.warehouseAddIndex = index;
                this.newOrder[type][index].warehouse_id = null;
                $("#addWarehouseModal").modal("show");
            } else {
                let warehouse = null;
                if (
                    
                    type == "customerWarehouses"
                ) {
                    console.log("index customerWarehouses");
                    warehouse = this.customerWarehouses.find(
                        (x) => (x.id == event.target.value)
                    );
                } 
                else if(type == "billTo"){
                     warehouse = this.newOrder.customer;
                    //  warehouse = this.customerWarehouses.find(
                    //     (x) => (x.id == event.target.value)
                    // );
                }
                else {
                    warehouse = this.warehouses.find(
                        (x) => (x.id == event.target.value)
                    );
                }

                console.log(warehouse,index);
                 if(type == "billTo"){
                    // if (warehouse) {
                    //     let address = warehouse.contact_name+ '\n';
                    //     if (warehouse.contact_no) {
                    //         address += `, ${warehouse.contact_no}`+ '\n';
                    //     }
                    //     if (warehouse.state) {
                    //         address += `, ${warehouse.contact_no}`+ '\n';
                    //     }
                    //     if (warehouse.post_code) {
                    //         address += `, ${warehouse.contact_no}`;
                    //     }

                    //     this.newOrder[type][index].address = address;
                    // }
                     if (warehouse) {
                        let address = warehouse.company_name + '\n';
                        address += warehouse.address+ '\n';
                        if (warehouse.city) {
                            address += ` ${warehouse.city}`;
                        }
                        if (warehouse.state) {
                            address += ` ${warehouse.state}`;
                        }
                        if (warehouse.post_code) {
                            address += ` ${warehouse.post_code}`;
                        }
                        console.log("bill to ",warehouse);
                        this.newOrder[type][index].address = address;
                    }
                 }
                 else{
                    if (warehouse) {
                        let address = warehouse.name + '\n';
                        address += warehouse.address+ '\n';
                        if (warehouse.city) {
                            address += ` ${warehouse.city}`;
                        }
                        if (warehouse.state) {
                            address += ` ${warehouse.state}`;
                        }
                        if (warehouse.post_code) {
                            address += ` ${warehouse.post_code}`;
                        }

                        this.newOrder[type][index].address = address;
                    }
                 }
                
            }
        },
        addBillTo() {
            this.newOrder.billTo.push({
                id: null,
                warehouse_id: null,
                address: null,
            });
        },
        removeBillTo(index) {
            this.newOrder.billTo.splice(index, 1);
        },
        goBack() {
            this.$router.push({ name: "selectProducts" });
        },
        editCharge(index, charge) {
            this.charge = _.cloneDeep(charge);
            //console.log(this.charge)
            this.bus.$emit("setChargeDataWithIndex", charge, index);
            $("#extraChargeModal").modal("show");
        },
        extraChargeAdded(event) {
            if (event.chargeIndex != null) {
                this.charges[event.chargeIndex].cost_type =
                    event.chargeData.cost_type;
                this.charges[event.chargeIndex].amount =
                    event.chargeData.amount;
                this.charges[event.chargeIndex].quantity =
                    event.chargeData.quantity;
                //console.log(this.charges[event.chargeIndex])
            } else {
                this.charges.push(_.cloneDeep(event.chargeData));
            }
        },
        saveAsDraft() {
            this.$confirm({
                message: `Do you want to save as Draft?`,
                button: {
                    no: "No",
                    yes: "Yes",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.newOrder.is_draft = 1;
                        this.$refs.submitButton.click();
                    }
                },
            });
        },
        saveOrder(e) {
            if (this.saveDone) {
                self.setSuccessMessage("Order data already saved!");
                return false;
            }
            this.newOrder.products = this.newOrder.products.filter((x) => {
                if (x.quote_product_id) {
                    return this.newOrder.selectedProducts.includes(
                        x.quote_product_id
                    );
                } else {
                    return this.newOrder.selectedProducts.includes(
                        x.product_id
                    );
                }
            });
            let self = this;
            this.submitted = true;
            this.setOrdersLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            if (this.charges.length) {
                this.newOrder["charges"] = this.charges;
            }
            return axios
                .post(window.route("orders.store"), this.newOrder, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                        this.submitted = false;
                    } else {
                        self.saveDone = true;
                        self.setSuccessMessage("Order created successfully!");
                        this.setNewOrder({
                            id: null,
                            is_draft: 0,
                            is_stocking: 0,
                            stocking_terms: null,
                            warehouses: [],
                            customerWarehouses: [],
                            billTo: [],
                            customer_id: null,
                            sales_rep_id: null,
                            order_number: null,
                            order_date: null,
                            customer_terms: null,
                            customer_po: null,
                            eta: null,
                            fob: null,
                            notes: null,
                            customer_notes: null,
                            quotations: [],
                            customer: {
                                quotations_after_sent_to_customer: [],
                            },
                            products: [],
                            selectedProducts: [],
                        });
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                            self.$router.push({
                                name: "orderShow",
                                params: { id: data.data.id },
                            });
                        }, 10);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                    this.submitted = false;
                })
                .finally(() => {
                    self.setOrdersLoading(false);
                });
        },
        getSalesRep() {
            let self = this;
            this.setOrdersLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .get(window.route("so.sales_rep"), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.salesReps = [];
                        if (data.data.length) {
                            data.data.forEach((x) => {
                                this.salesReps.push({
                                    value: x.id,
                                    text: x.name,
                                });
                            });
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setOrdersLoading(false);
                });
        },
        getWarehouses(is_customer = 0) {
            let self = this;
            this.setOrdersLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            let url = window.route("getWarehouses");
            if (is_customer) {
                if (this.newOrder.customer_id) {
                    url = window.route("getWarehouses", {
                        customer_id: this.newOrder.customer_id,
                    });
                } else {
                    return;
                }
            }
            return axios
                .get(url, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    },
                })
                .then(({ data }) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        if (is_customer) {
                            this.customerWarehouses = data.data;
                            /*let defaultWarehouses = this.customerWarehouses.filter((x) => x.is_default);
                            if(defaultWarehouses.length &&
                                (this.newOrder.customerWarehouses[0].address == null || this.newOrder.customerWarehouses[0].address == '') &&
                                this.newOrder.customerWarehouses[0].warehouse_id == null) {
                                this.newOrder.customerWarehouses[0].warehouse_id = defaultWarehouses[0].id;
                            }*/
                        } else {
                            this.warehouses = data.data;
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(
                        error.response && error.response.errorMessage
                            ? error.response.errorMessage
                            : error.message
                    );
                })
                .finally(() => {
                    self.setOrdersLoading(false);
                });
        },
        getQuillToolbar() {
            return [
                [
                    {
                        size: [],
                    },
                    "bold",
                    {
                        color: [],
                    },
                    {
                        background: [],
                    },
                    {
                        list: "ordered",
                    },
                    {
                        list: "bullet",
                    },
                ],
            ];
        },
    },
    watch: {
        "newOrder.is_stocking": {
            handler: function (after, before) {
                if (after == 1) {
                    this.newOrder.warehouses = [
                        {
                            id: null,
                            warehouse_id: null,
                            address: null,
                        },
                    ];

                    if (this.warehouses.length) {
                        let defaultWarehouses = this.warehouses.filter(
                            (x) => x.is_default
                        );
                        if (defaultWarehouses.length) {
                            this.newOrder.warehouses[0].warehouse_id =
                                defaultWarehouses[0].id;
                        }
                    }
                } else {
                    this.newOrder.warehouses = [];
                }
            },
        },
        eta_time: {
            handler: function (after, before) {
                if (after) {
                    let times = after.split("_");
                    let unit = "days";
                    if (times.length === 2 && times[1] === "W") {
                        unit = "weeks";
                    }
                    this.newOrder.eta = moment()
                        .add(times[0], unit)
                        .format("MM/DD/YYYY");
                }
            },
        },
        etaRange: {
            handler: function (after, before) {
                //console.log(after)
                if (after.startDate) {
                    this.newOrder.eta = moment(after.startDate).format(
                        "MM/DD/YYYY"
                    );
                }
            },
        },
    },
    computed: {
        ...mapState(["userState", "salesOrderState"]),
        ...mapGetters([
            "isAuth",
            "getAuthUser",
            "commonErrors",
            "errorMessage",
            "successMessage",
            "ordersLoading",
            "getSalesOrderState",
            "loading",
            "settings",
            "maxNumOfShipToAddress",
        ]),
    },
    beforeDestroy() {
        /*this.setNewOrder({
            id: null,
            is_draft: 0,
            customer_id: null,
            sales_rep_id: null,
            order_number: null,
            order_date: null,
            customer_terms: null,
            customer_po: null,
            eta: null,
            fob: null,
            notes: null,
            customer_notes: null,
            quotations: [],
            customer: {
                quotations_after_sent_to_customer: []
            },
            products: [],
            selectedProducts: [],
        });*/
    },
};
</script>

<style scoped>
.error {
    color: red;
}

.calendars-container {
    width: 60% !important;
}
</style>
